import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  store: null,
};

const exportStoreSlice = createSlice({
  name: "exportStore",
  initialState,
  reducers: {
    setStore: (state, action) => {
      state.store = action.payload;
    },
  },
});

export const { setStore } = exportStoreSlice.actions;

export default exportStoreSlice.reducer;
